import { Modal, Form, Select, Input, InputNumber, Button } from "antd";
import { useEffect } from "react";

const { Option } = Select;
const { TextArea } = Input;

export function EditCostumeForm({
  visible,
  costume,
  onCancel,
  onSubmit,
  loading,
}) {
  const [form] = Form.useForm();
  const type = Form.useWatch("type", form);

  useEffect(() => {
    if (costume) {
      form.setFieldsValue({
        type: costume.type,
        size: costume.size,
        quantity: costume.quantity,
        depositAmount: costume.depositAmount,
        borrowStatus: costume.borrowStatus,
        buyStatus: costume.buyStatus,
        note: costume.note,
      });
    }
  }, [costume, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (values.type === "none") {
        values.buyStatus = null;
        values.borrowStatus = null;
      }
      await onSubmit(costume._id, values);
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const sizeOptions = [
    { value: "XS", label: "XS" },
    { value: "S", label: "S" },
    { value: "M", label: "M" },
    { value: "L", label: "L" },
    { value: "XL", label: "XL" },
    { value: "XXL", label: "XXL" },
  ];

  const borrowStatusOptions = [
    { value: "pending", label: "Chờ nhận" },
    { value: "borrowed", label: "Đã mượn" },
    { value: "returned", label: "Đã trả" },
    { value: "lost", label: "Mất" },
    { value: "cancelled", label: "Đã hủy" },
  ];

  const buyStatusOptions = [
    { value: "paid", label: "Đã thanh toán" },
    { value: "unpaid", label: "Chưa thanh toán" },
    { value: "cancelled", label: "Đã hủy" },
  ];

  return (
    <Modal
      title="Chỉnh sửa trang phục"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Hủy
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Lưu
        </Button>,
      ]}
      width={600}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="type"
          label="Loại"
          rules={[{ required: true, message: "Vui lòng chọn loại!" }]}
        >
          <Select placeholder="Chọn loại">
            <Option value="borrow">Mượn</Option>
            <Option value="buy">Mua</Option>
            <Option value="none">Không</Option>
          </Select>
        </Form.Item>

        <Form.Item name="size" label="Size">
          <Select placeholder="Chọn size" allowClear>
            {sizeOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="quantity"
          label="Số lượng"
          rules={[{ required: true, message: "Vui lòng nhập số lượng!" }]}
        >
          <InputNumber
            min={1}
            placeholder="Số lượng"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item name="depositAmount" label="Tiền đặt cọc">
          <InputNumber
            min={0}
            placeholder="Tiền đặt cọc"
            style={{ width: "100%" }}
          />
        </Form.Item>

        <Form.Item name="borrowStatus" label="Trạng thái mượn">
          <Select
            placeholder="Chọn trạng thái mượn"
            allowClear
            disabled={type === "buy" || type === "none"}
          >
            {borrowStatusOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="buyStatus" label="Trạng thái mua">
          <Select
            placeholder="Chọn trạng thái mua"
            allowClear
            disabled={type === "borrow" || type === "none"}
          >
            {buyStatusOptions.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="note" label="Ghi chú">
          <TextArea rows={3} placeholder="Nhập ghi chú..." />
        </Form.Item>
      </Form>
    </Modal>
  );
}
